module.exports = __webpack_public_path__ + "static/media/concisewhite.31dc7153.svg";